import { render, staticRenderFns } from "./h-form.vue?vue&type=template&id=cad81066&scoped=true&"
import script from "./h-form.vue?vue&type=script&lang=js&"
export * from "./h-form.vue?vue&type=script&lang=js&"
import style0 from "./h-form.vue?vue&type=style&index=0&id=cad81066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad81066",
  null
  
)

export default component.exports